import { formatI18nNumber } from 'utils/i18n-format-currency';
import { LOCALE_SEARCH_PATHS } from 'types/locales';

const BUY_MAX = 5000000;
const RENT_MAX = 5000;

export function getPriceRange(priceMin: number, priceMax: number, isRental: boolean) {
  const formattedMin = formatI18nNumber(priceMin || 0);
  const formattedMax = formatI18nNumber(priceMax || (isRental ? RENT_MAX : BUY_MAX));
  const isMaxRental = formattedMax === formatI18nNumber(RENT_MAX) && isRental;
  const isMaxBuy = formattedMax === formatI18nNumber(BUY_MAX) && !isRental;
  if (isMaxRental || isMaxBuy) {
    return `$${formattedMin}+`;
  } else {
    return `$${formattedMin}-${formattedMax}`;
  }
}

export function getSqftRange(sqftMin: number, sqftMax: number) {
  if (sqftMin || sqftMax) {
    const min = formatI18nNumber(sqftMin || 0);
    const max = formatI18nNumber(sqftMax || 0);
    if (sqftMin && !sqftMax) {
      return `${min}+ sqft`;
    } else {
      return `${min}-${max} sqft`;
    }
  }
}

export type SavedSearchListingStatus = 'Active' | 'Leased' | 'Sold' | 'Expired' | 'Pending';

export function getListingStatus(status: string, rental: boolean) : SavedSearchListingStatus {
  if (status === 'available') {
    return 'Active';
  } else if (status === 'not-available-sold') {
    return rental ? 'Leased': 'Sold';
  } else if (status === 'pending') {
    return 'Pending';
  } else {
    return 'Expired';
  }
}

export function getListingStatusLocalized(status: string, rental: boolean) {
  if (status === 'available') {
    return LOCALE_SEARCH_PATHS.FILTER_STATUS_ACTIVE;
  } else if (status === 'not-available-sold') {
    return rental ? LOCALE_SEARCH_PATHS.FILTER_STATUS_LEASED : LOCALE_SEARCH_PATHS.FILTER_STATUS_SOLD;
  } else if (status === 'pending') {
    return LOCALE_SEARCH_PATHS.FILTER_STATUS_PENDING;
  } else {
    return LOCALE_SEARCH_PATHS.FILTER_STATUS_EXPIRED;
  }
}
